module.exports = __webpack_public_path__ + "img/gym.e8503a86.png";